import { Box, Menu } from "@mui/material";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import "./translations";

import { SupportIcon } from "@/assets";
import { cookieBanner } from "@/utils/tracking/tealium-tracker";

import { HeaderMenuItem } from "../HeaderMenuItem";
import { HeaderMenuSectionTitle } from "../HeaderMenuSectionTitle";

export type SupportMenuProps = {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
};

const deprecatedDomains = [
  "app.dev.indexportfolio.sprengnetter.de",
  "app.test.indexportfolio.sprengnetter.de",
  "app.indexportfolio.sprengnetter.de",
];

const isDeprecatedDomain = deprecatedDomains.includes(window.location.hostname);

export const SupportMenu = ({ anchorEl, open, onClose }: SupportMenuProps): JSX.Element => {
  const { t } = useTranslation("SupportMenu");
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box sx={{ p: "30px", pt: 0 }}>
        <HeaderMenuSectionTitle title={t("contactSupport")} />
        <HeaderMenuItem label="+49 2641 827 3002" icon={SupportIcon} linkHref="tel:+49 2641 827 3002" />
        <HeaderMenuItem label="hilfe@sprengnetter.de" icon={SupportIcon} linkHref="mailto:hilfe@sprengnetter.de" />

        <HeaderMenuSectionTitle title={t("sprengnetterLegalInformation.title")} />
        {!isDeprecatedDomain && (
          <HeaderMenuItem
            label={t("sprengnetterLegalInformation.cookiesSettings")}
            primary={true}
            onClick={() => {
              cookieBanner();
              onClose();
            }}
          />
        )}
        <HeaderMenuItem
          label={t("sprengnetterLegalInformation.imprint")}
          onClick={onClose}
          linkHref="https://www.sprengnetter.de/impressum-von-sprengnetter/"
        />
        <HeaderMenuItem
          label={t("sprengnetterLegalInformation.privacy")}
          onClick={onClose}
          linkHref="https://www.sprengnetter.de/datenschutz/"
        />
        <HeaderMenuItem
          label={t("sprengnetterLegalInformation.terms")}
          onClick={onClose}
          linkHref="https://www.sprengnetter.de/agb-von-sprengnetter/"
        />
      </Box>
    </Menu>
  );
};
